import Vue from 'vue'
import Vuex from 'vuex'
import shopCartModule from './shopCart'
import eleCardModule from './eleCard'
import orderModule from './order'
// 获取自定义颜色。
const themeColor = getComputedStyle(document.body)
  .getPropertyValue('--tc');

Vue.use(Vuex)

export default new Vuex.Store({
  
  state: {
    vpnNumber:'',
    count: 101,
    tc: themeColor, // 主题色
    vpnId: localStorage.getItem('vpnId')||'', // vpnid。 门店id
    vpnInfo:{name:'',code:'',payType:null},
    cardInfo:{id:null,code:''},
    websocketHistory: '',
    historyScollTop: '', // 首页的滚动位置
    userInfo: '', // 个人用户信息
    homeDoorInfo: '', // 首页的门店信息
    browserType: '', // 浏览器类型
    OpenId: '', // OpenId
    isAttention: '', // 存储用户关注状态到storage
    test: '',
    loc: {
      name: 'andy凌云',
      age: localStorage.getItem('age') || '',
    },
    pointConnet:null
  },
  getters: {
    evenOrOdd: state => state.count % 2 === 0 ? 'even' : 'odd'
  },
  mutations: {
    // 设置store项的值
    setStoreVal(state, objParam, ...a) {
      try {
        let objToArr = Object.entries(objParam);
        const key = objToArr[0][0];
        const val = objToArr[0][1];
        state[key] = val;
      } catch (error) {
        console.log(`%c error` + '', 'background-image:color:transparent;color:red;font-size:2em');
        console.log(error);
      }

    },
    // 设置vpnId
    set_vpnid(state, id) {
      localStorage.setItem('vpnId',Number(id)) 
      state.vpnId = Number(id);
    },
    set_vpnInfo(state, data) {
      state.vpnInfo = data;
    },
    // set_deskcode(state, data) {
    //   state.deskCode = data;
    // },
    test(state, data) {
      state.test = data;
    },
    // 设置主题色
    set_themecolor(state, color) {
      state.tc = color;
    },
    set_localstorage(state, obj) {
      state.loc = obj;
    },
    change_locname(state, name) {
      state.loc.name = name;
    },
    add_count(state, num) {
      state.count += num;
    },
    change_age(state, age) {
      state.loc.age = age;
      localStorage.setItem('age', age);
    },
    // 设置首页滚动高度
    set_scrolltop(state, height) {
      state.historyScollTop = height;
    },
    // 获取浏览器类型
    get_browsertype(state, objData) {
      state.browserType = objData;
    },
    set_cardinfo(state, objData) {
      state.cardInfo = objData;
    },
    set_point_connet(state, data) {
      state.pointConnet = data;
    }
  },
  actions: {
    add_count: (a, view, ...b) => {
      // setTimeout(() => {
      //   commit('add_count', view);
      // }, 2000);
    },
    increment: ({ commit }) => commit('increment'),
    decrement: ({ commit }) => commit('decrement'),
    incrementIfOdd({ commit, state }) {
      if ((state.count + 1) % 2 === 0) {
        commit('increment')
      }
    },
    incrementAsync({ commit }, view) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit('test', view);
          resolve(view)
        }, 3000)
      })
    }
  },
  modules: {
    shopCart:shopCartModule,
    order:orderModule,
    eleCard:eleCardModule
  }
})
